import React from 'react';
import CloseIcon from '../../../assets/svg/close_24px.svg';
import styles from './Chips.module.scss';

type Props = {
    title: string;
    onClose?: () => void;
}

const Chip = ({title, onClose}: Props) => {
    return <section className={styles.chip}>
        <p>
            {title}
        </p>
        {onClose ? <button type={'button'} onClick={onClose}>
            <img src={CloseIcon} alt='Close icon'/>
        </button>
        : null
        }
    </section>
}

export default Chip;